import { InvoiceApprovalData } from "../Data/InvoiceApproval.data";

export const setAllDropDownField = (apiResponse) => {
    if (!Array.isArray(apiResponse) || apiResponse.length === 0) {
        return;
    }
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        // account info
        "searchByApprover": filterDropDownList("Approver List"),
    };

    const formFields = [...InvoiceApprovalData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList && dropdownList.length > 0 && field?.fieldSetting) {
            field.fieldSetting.options = dropdownList;
        }
    });
};